/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {Docs} from 'components/layout';
import {getIntegrations} from 'api/get-integrations';
import {getExtensions} from 'api/get-extensions';
import {Warning, Tip, Info, WhitelistDetails} from 'ui';
export const lastUpdatedDate = new Date(1789689600000);
export async function getStaticProps() {
  const integrations = await getIntegrations();
  const extensions = await getExtensions();
  return {
    props: {
      ...integrations,
      extensions,
      meta: {
        title: null,
        description: null,
        lastUpdatedDate: "Fri Sep 18 2026 00:00:00 GMT+0000 (Coordinated Universal Time)",
        slug: "voucherify",
        type: "destination",
        icon: null,
        toc: [{
          "value": "Supported syncing",
          "depth": 0,
          "id": "supported-syncing"
        }, {
          "value": "Connect to Voucherify",
          "depth": 0,
          "id": "connect-to-voucherify"
        }, {
          "value": "Connect a dedicated cluster",
          "depth": 1,
          "id": "connect-a-dedicated-cluster"
        }, {
          "value": "Sync configuration",
          "depth": 0,
          "id": "sync-configuration"
        }, {
          "value": "Syncing customers",
          "depth": 1,
          "id": "syncing-customers"
        }, {
          "value": "Syncing events",
          "depth": 1,
          "id": "syncing-events"
        }, {
          "value": "Syncing segments",
          "depth": 1,
          "id": "syncing-segments"
        }, {
          "value": "Tips and troubleshooting",
          "depth": 0,
          "id": "tips-and-troubleshooting"
        }, {
          "value": "Bulk ingestion",
          "depth": 1,
          "id": "bulk-ingestion"
        }, {
          "value": "Validate your setup",
          "depth": 1,
          "id": "validate-your-setup"
        }, {
          "value": "Common errors",
          "depth": 1,
          "id": "common-errors"
        }, {
          "value": "Live debugger",
          "depth": 1,
          "id": "live-debugger"
        }, {
          "value": "Sync alerts",
          "depth": 1,
          "id": "sync-alerts"
        }]
      }
    },
    revalidate: 60
  };
}
const MDXLayout = ({children, ...props}) => _jsx(Docs, Object.assign({}, props, {
  children: children
}));
function MDXContent(props = {}) {
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, {})
  })) : _createMdxContent();
  function _createMdxContent() {
    const _components = Object.assign({
      p: "p",
      h2: "h2",
      table: "table",
      thead: "thead",
      tr: "tr",
      th: "th",
      tbody: "tbody",
      td: "td",
      a: "a",
      strong: "strong",
      ul: "ul",
      li: "li",
      h3: "h3",
      code: "code",
      h4: "h4",
      pre: "pre",
      span: "span"
    }, _provideComponents(), props.components), {EventSyncWarning, CommonErrorsPreface, LiveDebugger, SyncAlerts} = _components;
    if (!CommonErrorsPreface) _missingMdxReference("CommonErrorsPreface", true);
    if (!EventSyncWarning) _missingMdxReference("EventSyncWarning", true);
    if (!LiveDebugger) _missingMdxReference("LiveDebugger", true);
    if (!SyncAlerts) _missingMdxReference("SyncAlerts", true);
    return _jsxs(_Fragment, {
      children: [_jsx(_components.p, {
        children: "Voucherify is a promotion and loyalty platform for coupons, referrals, and loyalty programs. Hightouch keeps Voucherify customers up to date, tracks custom events against them, and maintains segment membership from your warehouse data."
      }), "\n", _jsx(_components.h2, {
        id: "supported-syncing",
        children: "Supported syncing"
      }), "\n", _jsxs(_components.table, {
        children: [_jsx(_components.thead, {
          children: _jsxs(_components.tr, {
            children: [_jsx(_components.th, {
              children: "Sync Type"
            }), _jsx(_components.th, {
              children: "Description"
            }), _jsx(_components.th, {
              children: "Supported Sync Modes"
            }), _jsx(_components.th, {
              children: "API Reference"
            })]
          })
        }), _jsxs(_components.tbody, {
          children: [_jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "#syncing-customers",
                children: _jsx(_components.strong, {
                  children: "Customers"
                })
              })
            }), _jsx(_components.td, {
              children: "Sync data from any source to Contacts in Voucherify"
            }), _jsx(_components.td, {
              children: "Upsert"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "https://docs.voucherify.io/api-reference/customers/customer-object",
                children: "Upsert a customer ↗"
              })
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "#syncing-events",
                children: _jsx(_components.strong, {
                  children: "Events"
                })
              })
            }), _jsx(_components.td, {
              children: "Sync data from any source to custom events in Voucherify"
            }), _jsx(_components.td, {
              children: "Insert"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "https://docs.voucherify.io/api-reference/events/track-custom-event",
                children: "Track a custom event ↗"
              })
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "#syncing-segments",
                children: _jsx(_components.strong, {
                  children: "Segments"
                })
              })
            }), _jsx(_components.td, {
              children: "Sync data from any source to active segments in Voucherify"
            }), _jsx(_components.td, {
              children: "Add, Remove"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "https://docs.voucherify.io/api-reference/segments/create-segment",
                children: "Create a segment ↗"
              })
            })]
          })]
        })]
      }), "\n", _jsxs(_components.p, {
        children: ["For more information about sync modes, refer to the ", _jsx(_components.a, {
          href: "/syncs/types-and-modes#sync-modes",
          children: "sync modes"
        }), " docs."]
      }), "\n", _jsx(_components.h2, {
        id: "connect-to-voucherify",
        children: "Connect to Voucherify"
      }), "\n", _jsxs(_components.p, {
        children: ["Go to the ", _jsxs(_components.a, {
          href: "https://app.hightouch.com/destinations?from=docs",
          children: [_jsx(_components.strong, {
            children: "Destinations"
          }), " overview page"]
        }), " and click the ", _jsx(_components.strong, {
          children: "Add destination"
        }), " button. Select ", _jsx(_components.strong, {
          children: "Voucherify"
        }), " and click ", _jsx(_components.strong, {
          children: "Continue"
        }), ". You can then authenticate Hightouch to ", _jsx(_components.strong, {
          children: "Voucherify"
        }), "."]
      }), "\n", _jsx(_components.p, {
        children: "Enter the following fields into Hightouch:"
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: [_jsx(_components.strong, {
            children: "Region"
          }), " — The region your Voucherify project is hosted in. Select ", _jsx(_components.strong, {
            children: "EU"
          }), ", ", _jsx(_components.strong, {
            children: "US"
          }), ", or ", _jsx(_components.strong, {
            children: "APAC"
          }), " for a project on one of Voucherify's shared clusters, or ", _jsx(_components.strong, {
            children: "Dedicated cluster"
          }), " if Voucherify assigned your project its own cluster."]
        }), "\n", _jsxs(_components.li, {
          children: [_jsx(_components.strong, {
            children: "Cluster ID"
          }), " — Required when the region is ", _jsx(_components.strong, {
            children: "Dedicated cluster"
          }), ". See ", _jsx(_components.a, {
            href: "#connect-a-dedicated-cluster",
            children: "Connect a dedicated cluster"
          }), "."]
        }), "\n", _jsxs(_components.li, {
          children: [_jsx(_components.strong, {
            children: "Application ID"
          }), " — Your Voucherify application ID."]
        }), "\n", _jsxs(_components.li, {
          children: [_jsx(_components.strong, {
            children: "App token"
          }), " — The secret key paired with the application ID."]
        }), "\n"]
      }), "\n", _jsx(_components.p, {
        children: "The application ID and token must be able to read segments, because Hightouch lists segments to test the connection."
      }), "\n", _jsx(_components.h3, {
        id: "connect-a-dedicated-cluster",
        children: "Connect a dedicated cluster"
      }), "\n", _jsx(_components.p, {
        children: "Voucherify assigns one immutable API endpoint per project. A project on a dedicated cluster answers on its own host, and calls to a shared host fail even though the credentials are valid."
      }), "\n", _jsxs(_components.p, {
        children: ["Find the endpoint in your Voucherify project settings and enter the first hostname label as the ", _jsx(_components.strong, {
          children: "Cluster ID"
        }), ". For the endpoint ", _jsx(_components.code, {
          children: "https://cluster1.api.voucherify.io"
        }), ", the cluster ID is ", _jsx(_components.code, {
          children: "cluster1"
        }), ". Enter the label on its own, not the full URL."]
      }), "\n", _jsx(_components.h2, {
        id: "sync-configuration",
        children: "Sync configuration"
      }), "\n", _jsxs(_components.p, {
        children: ["Once you've set up your Voucherify destination and have a ", _jsx(_components.a, {
          href: "/getting-started/concepts#models",
          children: "model"
        }), " to pull data from, you can set up your sync configuration to begin syncing data. Go to the ", _jsxs(_components.a, {
          href: "https://app.hightouch.com/syncs?from=docs",
          children: [_jsx(_components.strong, {
            children: "Syncs"
          }), " overview page"]
        }), " and click the ", _jsx(_components.strong, {
          children: "Add sync"
        }), " button to begin. Then, select the relevant model and the Voucherify destination you want to sync to."]
      }), "\n", _jsx(_components.h3, {
        id: "syncing-customers",
        children: "Syncing customers"
      }), "\n", _jsx(_components.p, {
        children: "Sync data from any source to Contacts in Voucherify."
      }), "\n", _jsx(_components.h4, {
        id: "record-matching",
        children: "Record matching"
      }), "\n", _jsxs(_components.p, {
        children: ["To match rows from your model to customers in Voucherify, you need to select the model column that contains values that match the ", _jsx(_components.strong, {
          children: "Source ID"
        }), " field.\nRefer to the ", _jsx(_components.a, {
          href: "/syncs/record-matching",
          children: "record matching docs"
        }), " for more information."]
      }), "\n", _jsx(_components.h4, {
        id: "field-mapping",
        children: "Field mapping"
      }), "\n", _jsxs(_components.p, {
        children: ["Hightouch lets you sync customer fields via ", _jsx(_components.a, {
          href: "/syncs/mapping-data",
          children: "field mapping"
        }), ".\nYou can map data from any of your model columns to default and custom customer fields.\nEnsure your model's columns have the same data types as the fields you want to sync to."]
      }), "\n", _jsx(_components.h4, {
        id: "delete-behavior",
        children: "Delete behavior"
      }), "\n", _jsxs(_components.p, {
        children: ["The ", _jsx(_components.a, {
          href: "/syncs/overview#delete-behavior",
          children: "delete behavior"
        }), " you select dictates what to do when a row no longer appears in your model's query results. You have the following options:"]
      }), "\n", _jsxs(_components.table, {
        children: [_jsx(_components.thead, {
          children: _jsxs(_components.tr, {
            children: [_jsx(_components.th, {
              children: "Behavior"
            }), _jsx(_components.th, {
              children: "Description"
            })]
          })
        }), _jsxs(_components.tbody, {
          children: [_jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.strong, {
                children: "Do nothing"
              })
            }), _jsx(_components.td, {
              children: "Keep the customer in Voucherify with all its synced fields"
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.strong, {
                children: "Delete"
              })
            }), _jsx(_components.td, {
              children: "Delete the synced customers from Voucherify"
            })]
          })]
        })]
      }), "\n", _jsx(_components.h4, {
        id: "use-bulk-ingestion",
        children: "Use bulk ingestion"
      }), "\n", _jsxs(_components.p, {
        children: ["High-volume customer syncs can send batches to Voucherify's bulk ingestion endpoints instead of the standard API. See ", _jsx(_components.a, {
          href: "#bulk-ingestion",
          children: "Bulk ingestion"
        }), " for when to turn it on and what you give up."]
      }), "\n", _jsx(_components.h3, {
        id: "syncing-events",
        children: "Syncing events"
      }), "\n", _jsx(_components.p, {
        children: "Sync data from any source to custom events in Voucherify."
      }), "\n", _jsx(EventSyncWarning, {}), "\n", _jsx(_components.h4, {
        id: "record-matching-1",
        children: "Record matching"
      }), "\n", _jsxs(_components.p, {
        children: ["You can match rows from your model to events in Voucherify on any column in your model and any field in Voucherify. Ensure the data types of the model column and Voucherify field you select match.\nRefer to the ", _jsx(_components.a, {
          href: "/syncs/record-matching",
          children: "record matching docs"
        }), " for more information."]
      }), "\n", _jsx(_components.h4, {
        id: "field-mapping-1",
        children: "Field mapping"
      }), "\n", _jsx(_components.p, {
        children: "Hightouch lets you sync event properties via field mapping."
      }), "\n", _jsx(_components.p, {
        children: "The event name must match a custom event schema defined in the Voucherify dashboard, and each metadata field you map must exist on that schema."
      }), "\n", _jsx(_components.h4, {
        id: "use-bulk-ingestion-1",
        children: "Use bulk ingestion"
      }), "\n", _jsxs(_components.p, {
        children: ["High-volume event syncs can send batches to Voucherify's bulk ingestion endpoints instead of the standard API. See ", _jsx(_components.a, {
          href: "#bulk-ingestion",
          children: "Bulk ingestion"
        }), " for when to turn it on and what you give up."]
      }), "\n", _jsx(_components.h3, {
        id: "syncing-segments",
        children: "Syncing segments"
      }), "\n", _jsx(_components.p, {
        children: "Sync data from any source to active segments in Voucherify."
      }), "\n", _jsx(_components.h4, {
        id: "record-matching-2",
        children: "Record matching"
      }), "\n", _jsxs(_components.p, {
        children: ["To match rows from your model to segments in Voucherify, you need to select the model column that contains values that match the ", _jsx(_components.strong, {
          children: "Source ID"
        }), " field.\nRefer to the ", _jsx(_components.a, {
          href: "/syncs/record-matching",
          children: "record matching docs"
        }), " for more information."]
      }), "\n", _jsx(_components.h4, {
        id: "field-mapping-2",
        children: "Field mapping"
      }), "\n", _jsxs(_components.p, {
        children: ["Hightouch lets you sync segment fields via ", _jsx(_components.a, {
          href: "/syncs/mapping-data",
          children: "field mapping"
        }), ".\nYou can map data from any of your model columns to the default segment fields.\nEnsure your model's columns have the same data types as the fields you want to sync to."]
      }), "\n", _jsx(_components.h2, {
        id: "tips-and-troubleshooting",
        children: "Tips and troubleshooting"
      }), "\n", _jsx(_components.h3, {
        id: "bulk-ingestion",
        children: "Bulk ingestion"
      }), "\n", _jsx(_components.p, {
        children: "Voucherify runs a separate pair of bulk ingestion endpoints for high-volume customer and event syncs. They accept a batch and queue it, rather than applying it during the request, which raises throughput well above the standard API."
      }), "\n", _jsx(_components.p, {
        children: "Bulk ingestion is available on customer and event syncs. Segment syncs always use the standard API."
      }), "\n", _jsx(_components.p, {
        children: "Two things must be true before you can use it:"
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "Voucherify must enable bulk ingestion for your account. Ask your Voucherify account team."
        }), "\n", _jsxs(_components.li, {
          children: ["The destination's region must be ", _jsx(_components.strong, {
            children: "Dedicated cluster"
          }), ", because Voucherify serves the bulk endpoints per cluster rather than on the public API. A sync with bulk ingestion turned on against a shared region fails."]
        }), "\n"]
      }), "\n", _jsxs(_components.p, {
        children: ["To turn it on, expand the optional settings at the bottom of the sync configuration and enable ", _jsx(_components.strong, {
          children: "Use bulk ingestion"
        }), ". The switch is off by default, and existing syncs keep using the standard API until you turn it on."]
      }), "\n", _jsx(Warning, {
        children: _jsx(_components.p, {
          children: "Bulk ingestion gives up row-level error reporting. Voucherify acknowledges a\nbatch before processing it, so a success means the batch was accepted, not\napplied, and rows Voucherify later rejects are never reported back. If\nVoucherify rejects the request itself, the whole batch fails rather than\nindividual rows. Keep bulk ingestion off for any sync where you need to see\nwhich rows failed."
        })
      }), "\n", _jsx(Info, {
        children: _jsxs(_components.p, {
          children: ["For Hightouch platform error codes related to Voucherify, see ", _jsx(_components.a, {
            href: "/developer-tools/error-codes#other-destinations",
            children: "Error codes:\nOther destinations"
          }), "."]
        })
      }), "\n", _jsx(_components.h3, {
        id: "validate-your-setup",
        children: "Validate your setup"
      }), "\n", _jsxs(_components.p, {
        children: ["After a sync run, open ", _jsx(_components.strong, {
          children: "Customers"
        }), " in the ", _jsx(_components.a, {
          href: "https://app.voucherify.io/",
          children: "Voucherify dashboard"
        }), " and search for a source ID from your model. Events appear on the customer's ", _jsx(_components.strong, {
          children: "Activity"
        }), " timeline. For a bulk ingestion sync, allow extra time: Voucherify queues the batch and applies it after acknowledging it, so records appear after the sync run already reports success."]
      }), "\n", _jsx(_components.h3, {
        id: "common-errors",
        children: "Common errors"
      }), "\n", _jsx(CommonErrorsPreface, {}), "\n", _jsx(_components.h4, {
        id: "voucherify-rejected-the-request-wrong_api_endpoint",
        children: "Voucherify rejected the request: wrong_api_endpoint"
      }), "\n", _jsx(_components.pre, {
        children: _jsx(_components.code, {
          className: "hljs",
          children: "403 wrong_api_endpoint\n"
        })
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "Cause:"
        }), " The destination points at a different cluster than the one Voucherify assigned your project. Because the endpoint is wrong rather than the credentials, the same misconfiguration returns a ", _jsx(_components.code, {
          children: "401"
        }), " on a sync run, which reads as a credentials problem."]
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "Solution:"
        }), " Check the API endpoint in your Voucherify project settings. If it isn't one of the shared region hosts, set ", _jsx(_components.strong, {
          children: "Region"
        }), " to ", _jsx(_components.strong, {
          children: "Dedicated cluster"
        }), " and enter the cluster label as the ", _jsx(_components.strong, {
          children: "Cluster ID"
        }), ". Voucherify's error names the correct host, and Hightouch surfaces it in the test connection message."]
      }), "\n", _jsx(_components.h4, {
        id: "missing-cluster-id",
        children: "Missing cluster ID"
      }), "\n", _jsx(_components.pre, {
        children: _jsxs(_components.code, {
          className: "hljs language-csharp",
          children: ["This Voucherify destination ", _jsx(_components.span, {
            className: "hljs-keyword",
            children: "is"
          }), " ", _jsx(_components.span, {
            className: "hljs-keyword",
            children: "on"
          }), " a dedicated cluster but names no cluster ID.\n"]
        })
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "Cause:"
        }), " The region is set to ", _jsx(_components.strong, {
          children: "Dedicated cluster"
        }), " but no cluster ID is saved. Destinations created through the API can reach this state, because saving through the API doesn't run the form's validation."]
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "Solution:"
        }), " Set the cluster ID to the first label of your Voucherify API endpoint, for example ", _jsx(_components.code, {
          children: "cluster1"
        }), " for ", _jsx(_components.code, {
          children: "https://cluster1.api.voucherify.io"
        }), "."]
      }), "\n", _jsx(_components.h4, {
        id: "bulk-ingestion-on-a-shared-region",
        children: "Bulk ingestion on a shared region"
      }), "\n", _jsx(_components.pre, {
        children: _jsxs(_components.code, {
          className: "hljs language-bash",
          children: ["This ", _jsx(_components.span, {
            className: "hljs-built_in",
            children: "sync"
          }), " uses bulk ingestion, ", _jsx(_components.span, {
            className: "hljs-built_in",
            children: "which"
          }), " Voucherify serves only on a dedicated cluster.\n"]
        })
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "Cause:"
        }), " The sync has ", _jsx(_components.strong, {
          children: "Use bulk ingestion"
        }), " enabled, but the destination's region is one of the shared clusters."]
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "Solution:"
        }), " Set the destination's region to ", _jsx(_components.strong, {
          children: "Dedicated cluster"
        }), " and enter your cluster ID, or turn bulk ingestion off for this sync."]
      }), "\n", _jsx(_components.h3, {
        id: "live-debugger",
        children: "Live debugger"
      }), "\n", _jsx(LiveDebugger, {}), "\n", _jsx(_components.h3, {
        id: "sync-alerts",
        children: "Sync alerts"
      }), "\n", _jsx(SyncAlerts, {})]
    });
  }
}
export default MDXContent;
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
